import * as React from "react";

interface OwnProps {
}

interface OwnState {
    q: string;
}

export class AdminSearch extends React.Component<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            q: "",
        };
    }

    public render() {
        return null;
        // return <div id="admin-search">
        //     <div className="search">

        //     </div>
        // </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/AdminSearch.tsx